export default {
    'create-warehouse': 'Create warehouse',
    'edit-warehouse': 'Edit warehouse',
    'warehouse-name': 'Warehouse name',
    notes: 'Notes',
    save: 'Save',
    cancel: 'Cancel',

    'delete-the-warehouse': 'Delete the warehouse',
    'are-you-sure-you-want-to-delete-the-warehouse': 'Do you want to delete this warehouse?',
    "create": "Will create",
    "are-you-sure": "Are you sure?",
    "contain": "Contains",
    "imported-materials": "Imported materials from",
    "warehouse-data": "Warehouse Data",
    "import-materials-from-warehouse": "Import materials from warehouse",
    "no-imported-materials": "Without importing any materials",
    "creating-warehouse": "The warehouse is currently being created",
    "warehouse-created-successfully": "The warehouse was created successfully <i class='fas fa-check primary--text mt-1 mx-1'></i>. Materials are currently being imported...",
    "link-materials": "Link Materials",
    "link-materials-alert": "The materials in the new warehouse will be automatically linked with all currently connected warehouses. This means any change to the linked materials will be applied to all connected warehouses.",
    "search-and-select-material": "Search and select material",
    headers: {
        'no': 'No.',
        'warehouse-name': 'Warehouse name',
        'notes': 'Notes',
        'actions': 'Actions',
    }
}